// extracted by mini-css-extract-plugin
export default {"productGallery":"cJ-z","inQuickShop":"dJ-z"};